'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('settings-edit-grid', {
      url: '/admin/settings/edit-grid/:id',
      template: '<settings-edit-grid></settings-edit-grid>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/settings/edit-grid/settings-edit-grid.routes.js